// extracted by mini-css-extract-plugin
export default {"price":"K9-z","onSale":"L9-z","msrpLabelPrice":"M9-z","msrpLabel":"N9-z","originalPrice":"O9-z","percentOff":"P9-z"};